import { getImage } from 'assets/img';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`

  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body{
    scroll-behavior: smooth;
    font-size:${(props) => props.theme.typography.htmlFontSize};
  }

  body {
    width: 100%;
    height: auto;
    min-height: 100vh;
    font-family: "Roboto";
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${getImage('background')});
  }

  #chat-widget-container{
    display: none !important;
  }

  .content{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

`;
